import { useEffect, useRef } from 'react';

/**
 * Runs a callback when a slice's `saved` flag turns true while the component
 * is mounted.
 *
 * Save thunks reset their flag to false when they start and set it to true on
 * success, so a false-to-true change identifies one completed save. A flag
 * that is already true on mount belongs to an earlier action and is ignored.
 *
 * @param saved The slice's saved flag, e.g. `selectSavedAddress`.
 * @param onSaved Called once per completed save.
 */
export function useOnSaved(saved: boolean, onSaved: () => void) {
  const wasSaved = useRef(saved);
  useEffect(() => {
    if (saved && !wasSaved.current) {
      onSaved();
    }
    wasSaved.current = saved;
  }, [saved]);
}
